// #region Dependencias
import styled from 'styled-components'
// #endregion

// #region Estilos
const StyledContainer = styled.div`
  margin: 0 auto;
`
// #endregion

/**
 * Componente que renderiza un contenedor.
 *
 * @class
 * @example <Container>...</Container>
 * @param {Object} props - Propiedades del componente.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const Container = ({ children, ...props }) => {
  return <StyledContainer {...props}>{children}</StyledContainer>
}

export default Container
